import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Accordion from '@material-ui/core/Accordion';
import { makeStyles } from '@material-ui/core/styles';
import withScrollToView from '../../../hooks/withScrollToView';

const useStyles = makeStyles(theme => ({
  hasCaseNotes: {
    backgroundColor: theme.palette.success.light
  }
}));

const NotesWrapper = ({ title, mainRef, description, children, type, hasNotes, selected }) => {
  const [opened, setOpened] = useState(selected);

  const changeHandler = (event, isExpanded) => {
    setOpened(isExpanded);
  };

  const classes = useStyles();
  const titleClassNames = [];
  if (['case_notes', 'preference_notes'].includes(type) && hasNotes) {
    titleClassNames.push(classes.hasCaseNotes);
  }

  return (
    <Accordion ref={mainRef} defaultExpanded={selected} expanded={opened} onChange={changeHandler}>
      <AccordionSummary className={titleClassNames.join(' ')} expandIcon={<ExpandMoreIcon />}>
        <div>
          <Typography>
            {title}{' '}
            {!hasNotes ? (
              <span style={{ color: 'grey', fontSize: 'small', fontStyle: 'italic' }}>(N/A)</span>
            ) : (
              ''
            )}
          </Typography>

          {description && <Typography variant="caption">{description}</Typography>}
        </div>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

NotesWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  description: PropTypes.string,
  hasNotes: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  mainRef: PropTypes.object.isRequired,
  selected: PropTypes.bool
};

NotesWrapper.defaultProps = {
  type: null,
  hasNotes: false,
  description: null,
  children: {},
  selected: false
};

export default withScrollToView(NotesWrapper);
